import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found container-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "not-found__code" }, "404", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "title title--h2 not-found__title" }, "Страница не найдена", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "not-found__text" }, "Запрошенная страница не существует или была удалена.", -1)),
    _createVNode(_component_ButtonComponent, {
      mod: "gradient-bg",
      onClick: _ctx.goToHome
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("На главную", -1)
      ]))]),
      _: 1
    }, 8, ["onClick"])
  ]))
}